
import { defineComponent } from 'vue';
import AppHeader from '@/components/AppHeader.vue';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
import DesktopHeader from '@/components/desktop/DesktopHeader.vue';
import DriveAsideMainMenu from '@/modules/drive/components/desktop/DriveAsideMainMenu.vue';

export default defineComponent({
  components: {
    DriveAsideMainMenu,
    DesktopHeader,
    AppHeader,
  },
  setup() {
    const mainStore = useMainStore();

    function updateSharingSettings(event, sharingSettings) {
      mainStore.sharingSettings.forEach((item) => {
        // eslint-disable-next-line no-param-reassign
        item[sharingSettings] = event;
      });
      mainStore.updateSharingSettings();
    }

    return {
      mainStore,
      updateSharingSettings,
    };
  },
});
